export const regDetailsEdited = {
    event: "reg_details_edited",
    eventCategory: "homepage",
    eventAction: "reg_details_edited"
};

export const mmyvsReview = {
    event: "mmyvs_review",
    eventCategory: "homepage",
    eventAction: "back_clicked",
    eventLabel: "mmvy_review"
};

export const regDetailedViewed = {
    event: "reg_no_full_details_viewed",
    eventCategory: "homepage",
    eventAction: "reg_no_full_details_viewed"
};

export const regDetailsConfirmCtaClick = {
    event: "reg_details_confirm_cta_click",
    eventCategory: "Desktop_Sell_Flow",
    eventAction: "reg_details_confirm_cta_click",
    eventLabel: "Reg Details Confirm CTA Click"
};
